export const OPEN_PASSENGERS_TO_BE_DELETED = 'OPEN_PASSENGERS_TO_BE_DELETED'

export default () => ({
  type: OPEN_PASSENGERS_TO_BE_DELETED,
})
